import React from 'react';
import { ErrorProps } from './Error.props';
import ErrorView from './Error.view';

const ErrorContainer = (props: ErrorProps): JSX.Element => {
  return <ErrorView />;
};

export default ErrorContainer;
